/**
 * Web wrapper for shared search hooks
 *
 * This thin wrapper binds the shared hooks to the web supabase client.
 * All the actual logic lives in /shared/hooks/use-search-filmmakers.ts
 */

import { supabase } from '@/integrations/supabase/client';
import { createSearchHooks } from '../../shared/hooks/use-search-filmmakers';

// Create hooks bound to web supabase client
const searchHooks = createSearchHooks(supabase);

// Filmmaker-specific search
export const useSearchFilmmakers = searchHooks.useSearchFilmmakers;
export const useFeaturedFilmmakers = searchHooks.useFeaturedFilmmakers;
export const useFilmmakerNameSearch = searchHooks.useFilmmakerNameSearch;
export const useFilmmakersByIds = searchHooks.useFilmmakersByIds;
export const useFilmmakersByUserIds = searchHooks.useFilmmakersByUserIds;

// Universal user search (filmmakers, clients, both)
export const useSearchUsers = searchHooks.useSearchUsers;
export const useUserNameSearch = searchHooks.useUserNameSearch;
export const useUsersByIds = searchHooks.useUsersByIds;

// Analytics hook with web platform
export function useSearchAnalytics(context: string) {
  return searchHooks.useSearchAnalytics(context, 'web');
}

// Re-export types for convenience
export type {
  SearchFilmmakerResult,
  SearchFilters,
  SearchAnalyticsData,
  SearchHookOptions,
  SearchUserResult,
  UserSearchFilters,
  AccountType,
  AccountTypeFilter,
} from '../../shared/hooks/use-search-filmmakers';
